<template>
    <div class="page-main">
        <div class="search-bar">
            <div class="left-bar">
                <Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>
                <Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>
                <Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>
            </div>
            <div class="right-bar">
                <!--搜索框-->
                <div class="right-mian_active" style="float: right;">
                    <input placeholder="请输入班级名称" class="input-cla" v-model="filters.keyWord"
                           v-on:keyup.enter="handleSearch"/>
                    <div class="search-btn" v-on:click="handleSearch">
                        <div class="search-icon">
                            <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                 height="100%"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-main-wrap">
            <div class="table-main">
                <div class="table-content">
                    <div class="header">
                        <Col :span="2">
                        <span>序号</span>
                        </Col>
                        <Col :span="4">
                        <span>学校名称</span>
                        </Col>
                        <Col :span="4">
                        <span>所属年级</span>
                        </Col>
                        <Col :span="4">
                        <span>班级名称</span>
                        </Col>
                        <Col :span="5">
                        <span>班级管理员</span>
                        </Col>
                        <Col :span="5">
                        <span>班级类型</span>
                        </Col>
                    </div>
                    <div class="row-wrap">
                        <template v-for="(item,index) in classList" v-if="classList.length>0">
                            <Row :gutter="12" :class="index % 2 === 0 ? 'row-single':'row-double'">
                                <Col :span="2" class="col-content">
                                <span>{{item.rowNum}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{item.schoolName ==='' ? '暂无':item.schoolName}}</span>
                                </Col>
                                <Col :span="4" class="col-content">
                                <span>{{item.grade_name ==='' ? '暂无':item.grade_name}}</span>
                                </Col>
                                <Col :span="4" class="col-content" v-if="filters.schoolId==''">
                                <span>{{item.className ==='' ? '暂无': item.className}}</span>
                                </Col>
                                <!--<Col :span="4" class="special-col-content" v-else>-->
                                    <!--<span v-on:click="lookIntoSchoolDetails(item)">{{item.className ==='' ? '暂无': item.className}}</span>-->
                                <!--</Col>-->
                                <Col :span="4" class="col-content" v-else>
                                    <span>{{item.className ==='' ? '暂无': item.className}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span>{{item.leaderNames==='' ? '暂无':item.leaderNames}}</span>
                                </Col>
                                <Col :span="5" class="col-content">
                                <span v-if="item.classType===1">行政班</span>
                                <span v-if="item.classType===3">分层班</span>
                                </Col>
                            </Row>
                        </template>
                        <template v-if="classList.length === 0">
                            <Row :gutter="12" class="row-single">
                                <Col :span="24">
                                <span>暂无数据</span>
                                </Col>
                            </Row>
                        </template>
                    </div>
                </div>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findClassList} from "../../../../service/api.js";

    export default {
        name: "class-list",
        data () {
            return {
                classList: [],
                filters: {
                    schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                    timeSolt: 0,
                    keyWord: '',
                    startDate: '',
                    endDate: ''

                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                }
            }
        },
        created () {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.params.schoolCode,
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部班级",
                    path: "",
                    name: "classList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 点击进入学校详细统计页
             */
            lookIntoSchoolDetails(item){
                this.$router.push({
                    name: "newSchoolDataDetails",
                    query: {
                        schoolName:item.schoolName,
                        schoolId:item.schoolId,
                        className:item.className,
                        classId:item.classId,
                        schoolCode:this.$route.params.schoolCode
                    }
                });
            },
            /**
             * 获取班级列表
             */
            async getClassList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findClassList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.classList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.pageParams.page = val;
                this.getClassList();
            },
            /**
             * 查询
             */
            handleSearch () {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.getClassList();
            },
            /**
             * 选择时间段
             */
            changeTimeSolt (type) {
                //反选的情况
                if (this.filters.timeSolt === type) {
                    this.filters.timeSolt = 0;
                    this.filters.startDate = '';
                    this.filters.endDate = '';
                } else {
                    this.filters.timeSolt = type;
                }
                //获取近一周时间
                if (this.filters.timeSolt === 1) {
                    this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 2) {
                    //获取近一月时间
                    this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 3) {
                    //获取近一年时间
                    this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';
                }
                this.handleSearch();
            }
        },
        mounted () {
            this.getClassList();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";
</style>
